import MainContentContainer, { MainContentHeader } from 'components/shared/containers/MainContentContainer';
import React from 'react';
import VerificationEnterCredsView from '../VerificationPage/components/VerificationEnterCredsView';
import "./styles.css";

/**
 * @function VerificationEnterCredsPage
 * @return {React.Component}
 * @exported true
 * @description The verification page
 */

export default function VerificationEnterCredsPage(props) {
    const data = props.data ? { data: props.data } : {};
    const ui = props.ui ? { ui: props.ui } : {};
    
    return(
        <MainContentContainer className="hide-chevron-icon verification-page" header={<MainContentHeader text="Verification" />}>
            <p className="top-description-text">You acknowledge that by continuing your data will be shared with the third-party merchant for the purposes
                of updating your payment information and use of your data by the third-party is governed by your agreement
                with them.</p>
            <VerificationEnterCredsView { ...data } { ...ui } />
        </MainContentContainer>
    );
}